import { Ng2StateDeclaration } from '@uirouter/angular';
import { TrainConnectivityReportComponent} from './components/train-connectivity-report/train-connectivity-report.component';


export const trainConnectivityReportState: Ng2StateDeclaration = {
    // parent: 'app', // declares that 'pools' is a child of 'app'
    name: 'train-connectivity',
    url: '/traincon/project/:projectId?date',
    component: TrainConnectivityReportComponent,
};

export const CONNECTIVITY_STATES = [
    trainConnectivityReportState
];


